import React from "react";

const Notifications: React.FC = () => (
  <svg
    width="10"
    height="12"
    viewBox="0 0 10 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.99967 11.6875C5.64134 11.6875 6.16634 11.1625 6.16634 10.5208H3.83301C3.83301 11.1625 4.35217 11.6875 4.99967 11.6875ZM8.49967 8.1875V5.27083C8.49967 3.48 7.54301 1.98083 5.87467 1.58417V1.1875C5.87467 0.703333 5.48384 0.3125 4.99967 0.3125C4.51551 0.3125 4.12467 0.703333 4.12467 1.1875V1.58417C2.45051 1.98083 1.49967 3.47417 1.49967 5.27083V8.1875L0.333008 9.35417V9.9375H9.66634V9.35417L8.49967 8.1875Z"
      fill="#80878F"
    />
  </svg>
);

export default Notifications;
